import {SiteEntity} from "../../commons/models/siteEntity.model";

export interface AiAgentModel extends SiteEntity {
  name: string;
  description: string;
  type: AiAgentType;
  active: boolean;
  archive?: boolean;
  aiChatOptions: AiChatOptions;
  systemPrompt: AiSystemPrompt;
  triggerPrompts: AiRecommendationTriggerPrompt[];
}

export interface AiChatOptions {
  aiModel: AiModel;
  frequencyPenalty?: number;
  maxTokens?: number;
  presencePenalty?: number;
  stopSequences?: string[];
  temperature?: number;
  topK?: number;
  topP?: number;
}

export interface AiRecommendationTriggerPrompt {
  triggerType: AiAgentTriggerType;
  userPrompt: AiUserPrompt;
  enabled: boolean;
}

export interface AiUserPrompt {
  instruction: string;
  variables: AiUserVariableType[] //???
}

export interface AiSystemPrompt {
  instruction: string;
}

export enum AiUserVariableType {
  VisitPlan = "VisitPlan",
  VisitAccount = "VisitAccount",
  VisitSlot = "VisitSlot",
  PlanningDraftRoute = "PlanningDraftRoute",
  PlanningDraftJob = "PlanningDraftJob",
  PlanningDraft = "PlanningDraft",
  PlanningDraftResources = "PlanningDraftResources",
  PlanningDraftAccountsData = "PlanningDraftAccountsData"
}

export enum AiAgentType {
  Chat = "Chat",
  Recommendation = "Recommendation"
}

export enum AiAgentTriggerType {
  VpSlotCreated = "VpSlotCreated",
  VpAccountCreated = "VpAccountCreated",
  Manual = "Manual"
}

export enum AiModel {

  GeminiPro_2_5 = "GeminiPro_2_5",
  GeminiFlashLatest = "GeminiFlashLatest",
  GeminiFlashLiteLatest = "GeminiFlashLiteLatest",
  GeminiFlash_2_5 = "GeminiFlash_2_5",
  GeminiFlashLite_2_5 = "GeminiFlashLite_2_5",
  GeminiFlash_3_0 = "GeminiFlash_3_0",
  GeminiFlashLite_3_1 = "GeminiFlashLite_3_1",
  GeminiFlashLite_3_5 = "GeminiFlashLite_3_5"
}
